<template>
  <div id="app">
    <home></home>
    <transition :name="$route.meta.transtionName ||'slide-right'">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import Home from '@/views/Home'

export default {
  components: {
    Home
  }
}
</script>

<style lang="scss">
@import '~@/assets/style/index.scss';
@font-face {
  font-family: CustomHelvetica;
  src: url('~@/assets/helveticaltstd-roman.otf');
}
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC',
    'Helvetica Neue', STHeiti, 'Microsoft Yahei', Tahoma, Simsun, sans-serif;
}
.digitFont {
  font-family: CustomHelvetica;
}
.slide-right-enter-active {
  animation: slideInRight 0.3s;
}

.slide-right-leave-active {
  animation: slideOutRight 0.3s;
}

.slide-down-enter-active {
  animation: slideInUp 0.3s;
}

.slide-down-leave-active {
  animation: slideOutDown 0.3s;
}

@keyframes slideInRight {
  from {
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes slideOutRight {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(100%, 0, 0);
  }
}

@keyframes slideInUp {
  from {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes slideOutDown {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 100%, 0);
  }
}
</style>
